import http from '@services/http';

export const limit = (data: IPostId) => {
  return http.post(`/admin/posts/${data.postId}/visibility.limit`, {});
};

export const unlimit = (data: IPostId) => {
  return http.post(`/admin/posts/${data.postId}/visibility.unlimit`, {});
};